import $ from 'jquery';
class Awards {

    constructor(){
        if ($("#awards-dropdown").length != 0){
            this.events();
        }
    }

    events() {
        $(this.awardChanged.bind(this));
        //  Register Listeners
        $("#awards-dropdown").on("change", this.awardChanged.bind(this));
    }


    //  Methods
    awardChanged(e){
        $.getJSON(dysData.root_url + '/wp-json/results/v1/awards?award=' + $('#awards-dropdown').val(), function(awards){
            //clear Existing table
            if ($('#awards-list').length > 0){
                $('#awards-list div').remove();
            }
            var htmlCode = `<div class="row">
            <div class="col-12  col-lg-1">
            </div>
            <div class="col-12 col-lg-10 info-block pt-0 text-truncate">
                <div class="row text-reverse">
                    <h4 class="text-center my-0 col-0 col-lg-1"></h4>
                    <h4 class="text-center my-0 col-4 col-lg-3">Year</h4>
                    <h4 class="text-center my-0 col-8 col-lg-8">Name</h4>
                </div>`;
            //$(`
            
            //`).appendTo('#awards-list');
            //create table with data
            for(var row=0; row<awards.length; row++) {
                //$(`
                htmlCode += `
                    <div class="row">
                        <p class="text-center col-0 d-none d-lg-block col-lg-1 text-style__b"></p>
                        <p class="text-center col-4 col-lg-3 text-style__b">${awards[row].year}</p>
                        <p class="text-center col-8 col-lg-8 text-style__b">${awards[row].winner}</p>
                    </div>`;
                //).appendTo('#awards-list');
            }
            //$(`
            htmlCode+=`
            </div>`;
            //`).appendTo('#awards-list');
            $(htmlCode).appendTo('#awards-list');
        });
    }
}
export default Awards;